<template>
  <div class="factor-scale">
    <div
      class="point"
      :style="{left: Math.max(0, point) + '%'}"
    >
      <div
        class="circle"
        :style="{'background-color': get_color(circle)}"
      >
        {{ round_half_down(factor) }}
      </div>
      <div
        class="line"
        :style="{'background-color': get_color(line)}"
      />
    </div>
    <div class="bar" />
    <div class="label">
      Your individual factor: <strong>{{ individual_factor }}</strong>
    </div>
  </div>
</template>

<script>
import {round_half_down} from "../utils";

export default {
  props: ['factor', 'individual_factor'],
  data() {
    return {
      point:0,
      circle:0,
      line:0
    }
  },
  watch: {
    'factor': function (s) { this.update_data(); },
    'individual_factor': function (s) { this.update_data(); }
  },
  methods: {
    round_half_down,
    get_color(percentage) {
      function gradient(t, start, middle, end) {
        return t >= 0.5 ? linear(middle, end, (t - .5) * 2) : linear(start, middle, t * 2);
      }
      function linear(s, e, x) {
        let r = byteLinear(s[1] + s[2], e[1] + e[2], x);
        let g = byteLinear(s[3] + s[4], e[3] + e[4], x);
        let b = byteLinear(s[5] + s[6], e[5] + e[6], x);
        return "#" + r + g + b;
      }
      function byteLinear(a, b, x) {
        let y = (('0x' + a) * (1 - x) + ('0x' + b) * x) | 0;
        return y.toString(16).padStart(2, '0') // hex output
      }
      return gradient(percentage, '#cc3333', '#ffcc00', '#669933');
    },
    update_data(){
      console.log(this.factor + '---'+this.individual_factor);
      if(this.factor <= this.individual_factor){
        this.point = parseFloat((this.factor>0?this.factor/this.individual_factor:0) * 100) - 1;
        this.circle = parseFloat(this.factor>0?this.factor/this.individual_factor:0);
        this.line = parseFloat(this.factor>0?this.factor/this.individual_factor:0);
      }else{
        let diff = this.factor - this.individual_factor;
        if(diff > this.individual_factor){
          this.point = 0;
          this.circle = 0;
          this.line = 0;
        }else{
          let f = this.individual_factor - diff;
          this.point = parseFloat((f>0?f/this.individual_factor:0) * 100) - 1;
          this.circle = parseFloat(f>0?f/this.individual_factor:0);
          this.line = parseFloat(f>0?f/this.individual_factor:0);
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
